module.exports = __webpack_public_path__ + "img/norway-male.aff25fb8.png";